import { RouteConfig } from 'vue-router'
import i18n from '@/i18n'

const routes: Array<RouteConfig> = [
    {
        path: '/settings',
        name: 'base_settings',
        meta: { title: i18n.t('integration') },
        component: () => import('@/modules/settings/views/SettingsBase.vue')
    },
    {
        path: '/settings/statuses',
        name: 'settings_statuses',
        meta: { title: i18n.t('integration') },
        component: () => import('@/modules/settings/views/OrderStatuses.vue')
    },
    {
        path: '/settings/payments',
        name: 'settings_payments',
        meta: { title: i18n.t('integration') },
        component: () => import('@/modules/settings/views/PaymentsMapping.vue')
    },
    {
        path: '/settings/warehouses',
        name: 'settings_warehouses',
        meta: { title: i18n.t('integration') },
        component: () => import('@/modules/settings/views/Warehouses.vue')
    },
    {
        path: '/settings/categories',
        name: 'settings_category_mappings',
        meta: { title: i18n.t('integration') },
        component: () => import('@/modules/settings/views/CategoryMappings.vue')
    },
    {
        path: '/settings/offerIssues',
        name: 'settings_offer_issues',
        meta: { title: i18n.t('integration') },
        component: () => import('@/modules/settings/views/OfferIssues.vue')
    },
    {
        path: '/settings/costs',
        name: 'settings_costs',
        meta: { title: i18n.t('integration') },
        component: () => import('@/modules/settings/views/Costs.vue')
    },
    {
        path: '/settings/catalogManagement',
        name: 'settings_catalog_management',
        meta: { title: i18n.t('integration') },
        component: () => import('@/modules/settings/views/CatalogManagement.vue')
    },
    {
        path: '/settings/exportOrder',
        name: 'settings_export_order',
        meta: { title: i18n.t('integration') },
        component: () => import('@/modules/settings/views/ExportOrder.vue')
    }
]

export default routes
